import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

export const Section = styled.section`
  padding: 4rem 0;
  @media (min-width: 768px) {
    padding: 6rem 0;
  }
`;

export const Grid = styled.div<{ columns?: number }>`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 0.75rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }
`;

export const Text = styled.p`
  color: var(--gray-600);
  line-height: 1.6;
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Title = styled.h2`
  font-size: 2.25rem;
  font-weight: 800;
  color: var(--gray-900);
  text-align: center;
  margin-bottom: 0.5rem;
  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

export const Subtitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 1rem;
  @media (min-width: 768px) {
    font-size: 1.875rem;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  font-weight: 600;
  transition: all 0.3s ease;
  background-color: ${props => props.variant === 'secondary' ? 'white' : 'var(--primary)'};
  color: ${props => props.variant === 'secondary' ? 'var(--gray-900)' : 'white'};
  border: ${props => props.variant === 'secondary' ? '1px solid var(--gray-200)' : 'none'};
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: ${props => props.variant === 'secondary' ? 'var(--gray-50)' : '#636363'};
  }
`;

export const NoticeBox = styled.div<{ color?: string }>`
  background-color: ${props => props.color || 'var(--yellow-50)'};
  border: 1px solid ${props => props.color?.replace('50', '100') || 'var(--yellow-100)'};
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 1rem 0;
`;

export const BenefitList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const BenefitItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  color: var(--gray-600);
  line-height: 1.5;
  svg {
    flex-shrink: 0;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
    color: var(--green-500);
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 0.5rem;
`;
 
 